import { Component, computed, OnInit, signal } from '@angular/core';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, Observable, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { Profile } from './models/profile';
import { UserService } from './services/user.service';
import { GoogleTagManagerService } from 'resolve-lib';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'resolve-practice';

  readonly #destroying$ = new Subject<void>();

  isLoggedIn: boolean = false;
  profile: Profile| null = null;

  constructor(
    private userService: UserService,
    private broadcastService: MsalBroadcastService,
    private gtmService: GoogleTagManagerService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.#destroying$),
        switchMap(() => this.userService.checkTokenStatus()),
        switchMap(() => this.userService.getProfileAsObservable().pipe(
          tap((profile: Profile | null) => {
            if(!!profile?.details?.userUuid){
              this.gtmService.pushLogin(profile.details.userUuid, profile.email);
            }
          })
        ))

      )
      .subscribe({
        next: (profile: Profile) => {
          if(!!profile){
            this.setIsLoggedIn(profile);
            this.router.navigate(['/rdata-aggregates']);
          }
        },
        error: (error) => {
          //Handle error thrown by authService, failure to get valid token
          console.error(error);

          //Since we can't get the active token silently, remove the tokens from storage and sign the user out.
          this.userService.logout();
        }
      });
  }

  login() {
    this.userService.login();
  }

  logout() {
    this.userService.logout();
  }

  setIsLoggedIn(profile: Profile) {
    this.isLoggedIn = this.userService.isLoggedIn();
    this.profile = profile;
  }
}
